export { subscribeCrossDomainCommunication } from '@atlassian/embedded-confluence-common/ccfe-entry-points';
